<script setup lang="ts">
import dayjs from 'dayjs';
import type { LineChartData } from '~/components/nrjx/chart/line/index.vue';

// Stores
const { consumptionResponse, loadingConsumption, areasToCompare, comparisonResponse, loadingComparison } =
  storeToRefs(chronologicalStore());

// Composables
const { options } = useExploreLineChart();

// Computed
const datasets = computed((): LineChartData => {
  if (!consumptionResponse.value?.items.length) {
    return { keys: [], lines: [] };
  }

  // Extraire les timestamps (keys)
  const keys = consumptionResponse.value.items.map((item) => dayjs(item.start).format('DD/MM/YYYY HH:mm'));

  const lines: LineChartData['lines'] = [];

  // Ligne principale (consommation de l'area actuelle)
  const mainLineValues = consumptionResponse.value.items.map((item) => item.avg_power);
  lines.push({
    color: '#1BA774',
    dashed: false,
    values: mainLineValues,
  });

  // Lignes de comparaison (autres areas)
  if (areasToCompare.value.length > 0 && comparisonResponse.value) {
    areasToCompare.value.forEach((comparedArea) => {
      const areaData = comparisonResponse.value?.compared_to.find((el) => el.area_id === comparedArea.id);

      if (areaData) {
        const comparedValues = consumptionResponse.value!.items.map((item) => {
          const power = areaData.consumption.items.find((el) => el.start === item.start)?.avg_power;
          return power ?? 0;
        });

        lines.push({
          color: comparedArea.color ?? '#ef4444',
          dashed: true, // Les lignes de comparaison en pointillés
          values: comparedValues,
        });
      }
    });
  }

  return {
    keys,
    lines,
  };
});

// Loading
const loading = computed(() => {
  if (areasToCompare.value.length > 0) {
    return loadingComparison.value;
  }
  return loadingConsumption.value;
});
</script>

<template>
  <nrjx-chart-line :options="options" :loading="loading" :data="datasets" :clickable="false" />
</template>
